var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch, Model, Prop } from 'vue-property-decorator';
let EnvironmentSelect = class EnvironmentSelect extends Vue {
    constructor() {
        super(...arguments);
        // protected selected: string | null = null;
        this.selected = [];
    }
    mounted() {
        if (this.$selected === 'both') {
            this.selected = ['individual', 'group'];
        }
        else {
            this.selected = [this.$selected];
        }
    }
    setSelected(type) {
        if (this.disabled) {
            return;
        }
        const index = this.selected.findIndex((element) => {
            return element === type;
        });
        if (index >= 0) {
            this.selected.splice(index, 1);
        }
        else {
            this.selected.push(type);
        }
    }
    classes(type) {
        return {
            disabled: this.disabled,
            selected: this.selected.includes(type),
        };
    }
    selectedChanged(type) {
        if (this.selected.includes('individual') && this.selected.includes('group')) {
            this.$emit('input', 'both');
        }
        else {
            this.$emit('input', this.selected[0]);
        }
    }
};
__decorate([
    Model('input'),
    __metadata("design:type", String)
], EnvironmentSelect.prototype, "$selected", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], EnvironmentSelect.prototype, "disabled", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], EnvironmentSelect.prototype, "single", void 0);
__decorate([
    Watch('selected'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EnvironmentSelect.prototype, "selectedChanged", null);
EnvironmentSelect = __decorate([
    Component({
    //
    })
], EnvironmentSelect);
export default EnvironmentSelect;
